import { useMemo } from 'react';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { useRouteId } from '@/shared/lib/useRouteId';
import { DeleteButton } from '@/shared/ui/list/DeleteButton';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig } from '@/shared/ui/list/types';
import { deleteSlide, fetchSlides, type Slide } from './api';
import { SLIDES_KEY, SlideModalButton } from './StorySlideModal';

const createConfig = (previewId: number): ListPageConfig<Slide> => ({
  queryKey: SLIDES_KEY,
  title: 'Сторис детальная',
  errorText: 'Ошибка загрузки сторис',
  fetchList: () => fetchSlides(previewId),
  rows: ['data'],
  paginated: false,
  headerActions: <SlideModalButton previewId={previewId} />,
  columns: [
    { header: '№', render: (slide) => slide.id },
    { header: 'Имя', render: (slide) => slide.name },
    {
      header: 'Картинка детальная',
      render: (slide) =>
        slide.content_image?.thumb_140_140 && <img src={slide.content_image.thumb_140_140} alt="" />,
    },
    {
      header: 'Тип сторис',
      render: (slide) => (slide.type === 'static' ? 'Cтатичная' : 'C призывом к действию'),
    },
    { header: 'Градиент первый', render: (slide) => slide.gradient_colors_1 },
    { header: 'Градиент второй', render: (slide) => slide.gradient_colors_2 },
    {
      header: 'Орентация сторис',
      render: (slide) => (slide.orientation === 'vertical' ? 'Вертикально' : 'Горизонтально'),
    },
    { header: 'Тип кнопки', render: (slide) => slide.type_button },
    { header: 'Url кнопки', render: (slide) => slide.uri_button },
    { header: 'Текст кнопки', render: (slide) => slide.text_button },
    { header: 'Стиль кнопки', render: (slide) => slide.style_button },
    { header: 'Дата создания', render: (slide) => formatUnixDateTime(slide.create_time) },
    { header: 'Дата обновления', render: (slide) => formatUnixDateTime(slide.update_time) },
    { header: 'Обновить', render: (slide) => <SlideModalButton previewId={previewId} slide={slide} /> },
    {
      header: 'Удалить',
      render: (slide) => <DeleteButton listKey={SLIDES_KEY} remove={() => deleteSlide(slide.id)} />,
    },
  ],
});

export const StoryDetailPage = () => {
  const previewId = useRouteId();
  const config = useMemo(() => createConfig(previewId), [previewId]);
  return <GenericListPage config={config} />;
};
